import { Audio } from '@/components/client/audio/audio'
import { tw } from '@/lib/utils'

interface LabFitPlayerProps {
  kicker: string
  hint: string
  url: string | null
  score: number | null
  group: string
  tone: 'initial' | 'tuned'
}

export const LabFitPlayer = ({ kicker, hint, url, score, group, tone }: LabFitPlayerProps) => {
  if (!url) return null

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-white/12 bg-white/6 p-4">
      <div className="flex items-baseline justify-between gap-3">
        <div>
          <p
            className={tw(
              'text-xs font-semibold tracking-[0.12em] uppercase',
              tone === 'initial' ? 'text-merigold' : 'text-sky-80'
            )}
          >
            {kicker}
          </p>
          <p className="mt-0.5 text-sm text-white/55">{hint}</p>
        </div>
        {score != null && (
          <span className="text-2xl leading-none font-semibold text-white tabular-nums">{score.toFixed(1)}</span>
        )}
      </div>
      <Audio url={url} variant="bars" compact group={group} tone="dark" />
    </div>
  )
}
